var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-custom-select" },
    [
      _vm.recurring
        ? _c(
            "el-select",
            {
              staticClass: "w-100",
              attrs: { placeholder: "Select Recurring Cycle" },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            _vm._l(_vm.options, function (opt, key) {
              return _c(
                "el-option",
                { key: key, attrs: { value: key, label: opt } },
                [_vm._v("\n      " + _vm._s(opt) + "\n    ")]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }